export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[92vh] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20cozy%20study%20room%20with%20stacked%20doujin%20books%20and%20manga%20volumes%20on%20a%20desk%2C%20warm%20coral%20and%20peach%20amber%20color%20palette%2C%20soft%20morning%20window%20light%2C%20hand%20drawn%20flat%20art%20style%2C%20gentle%20shadows%2C%20decorative%20and%20inviting%2C%20clean%20composition%20with%20plenty%20of%20negative%20space%20at%20top&width=1600&height=1000&seq=hero-main-2026&orientation=landscape')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary-950/60 via-primary-900/45 to-background-50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 py-24">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold tracking-wide">
          <i className="ri-download-cloud-2-fill"></i>
          本子网站资源下载一站式指南
        </span>

        <h1 className="font-display text-3xl md:text-5xl leading-snug text-background-50 mt-6">
          想存却不知道怎么下？
          <br />
          一次看懂本子网站下载全攻略
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-background-100/90 leading-relaxed">
          从打包下载、批量下载到离线下载，我们整理了完整可落地的本子网站下载教程与工具推荐。
          一步一步照着操作，就能把喜欢的资源安稳存进本地，再也不怕想存却下不到了。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#tutorial"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition-colors"
          >
            查看下载教程
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#methods"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-700 font-semibold hover:bg-background-100 transition-colors"
          >
            认识三种方式
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-background-100">
          {[
            { icon: "ri-archive-2-line", text: "打包下载" },
            { icon: "ri-stack-line", text: "批量下载" },
            { icon: "ri-cloud-off-line", text: "离线下载" },
          ].map((m) => (
            <span key={m.text} className="inline-flex items-center gap-2 text-sm">
              <i className={`${m.icon} text-accent-400`}></i>
              {m.text}
            </span>
          ))}
        </div>
      </div>

      <a
        href="#methods"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 -translate-x-1/2 w-10 h-10 flex items-center justify-center rounded-full border border-background-50/40 text-background-50 hover:bg-white/15 animate-bounce"
      >
        <i className="ri-arrow-down-s-line text-xl"></i>
      </a>
    </section>
  );
}